import { AppState } from '../../../redux/reducers';
import { useDispatch, useSelector, connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import {
  DefaultButton,
  FontWeights,
  getTheme,
  IconButton,
  IIconProps,
  IStackProps,
  mergeStyleSets,
  MessageBar,
  MessageBarType,
  Modal,
  PrimaryButton,
  Stack,
  TextField
} from '@fluentui/react';
import { ErrorMessageComponent } from '../../Error/ErrorMessageComponent';
import { MedicalInsurancePlan } from '../../../models/Entities/MedicalInsurances/MedicalInsurancePlan';

////i18Next
import { useTranslation, Trans } from 'react-i18next';

// store
import * as MedicalInsurancePlanStore from '../../../redux/middleware/MedicalInsurancePlansMiddleware';
import { NewMedicalInsurancePlan } from '../../../models/Entities/MedicalInsurances/NewMedicalInsurancePlan';

interface FormValidation {
  success: boolean;
  errors: string[];
}

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  MedicalInsuranceId: number;
  MedicalInsurancePlan: MedicalInsurancePlan | undefined;
}

export const MedicalInsurancePlanFormComponent = (props: IProps) => {
  const [submittedForm, setSubmittedForm] = useState<boolean>(false);
  const [FormValidationStatus, setFormValidationStatus] = useState<
    FormValidation | undefined
  >();

  const MedicalInsurancePlanState = useSelector(
    (state: AppState) => state.MedicalInsurancePlans
  );
  const dispatch = useDispatch();

  // MedicalInsurance state
  const [title, setTitle] = useState<string>();
  const [Description, setDescription] = useState<string>();
  const [Code, setCode] = useState<string>();
  
  //useTranslation()
  const [t] = useTranslation()

  // effects
  useEffect(() => {
    if (props.MedicalInsurancePlan) {
      setTitle(props.MedicalInsurancePlan.title);
      setDescription(props.MedicalInsurancePlan.description);
      setCode(props.MedicalInsurancePlan.code);
    } else {
      ResetForm();
    }
  }, [props.MedicalInsurancePlan]);

  useEffect(() => {
    if (
      submittedForm &&
      MedicalInsurancePlanState &&
      (MedicalInsurancePlanState.successAddingNewOne ||
        MedicalInsurancePlanState.successUpdatingOne)
    ) {
      ResetForm();
      props.dismissPanel();
    }
  }, [
    MedicalInsurancePlanState?.successAddingNewOne,
    MedicalInsurancePlanState?.successUpdatingOne
  ]);

  const ResetForm = () => {
    setTitle(undefined);
    setDescription(undefined);
    setCode(undefined);
    setFormValidationStatus(undefined);
    setSubmittedForm(false);
  };

  // Events

  const onChangeTitleTextFieldValue = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    setTitle(newValue || '');
  };

  const onChangeDescriptionTextFieldValue = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    setDescription(newValue || '');
  };

  const onChangeCodeTextFieldValue = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    setCode(newValue || '');
  };

  const HandleSaveForm = () => {
    setSubmittedForm(true);
    if (ValidateForm()) {
      var CurrentValues: MedicalInsurancePlan | NewMedicalInsurancePlan;
      if (props.MedicalInsurancePlan) {
        CurrentValues = {
          id: props.MedicalInsurancePlan.id,
          title: title!,
          description: Description,
          code: Code!,
          medicalInsuranceId: props.MedicalInsurancePlan.medicalInsuranceId
        };
        dispatch(
          mapDispatchToProps.SaveMedicalInsurancePlan(CurrentValues as MedicalInsurancePlan)
        );
      } else {
        CurrentValues = {
          title: title!,
          description: Description,
          code: Code!,
          medicalInsuranceId: props.MedicalInsuranceId
        };
        dispatch(mapDispatchToProps.AddMedicalInsurancePlan(CurrentValues));
      }
    }
  };

  const HandleCancelForm = () => {
    ResetForm();

    props.dismissPanel();
  };

  // footer
  const onRenderFooterContent = () => {
    return (
      <div className={contentStyles.footer}>
        <DefaultButton onClick={HandleCancelForm} className="OtherOption">
          <Trans i18nKey={'medicalInsurancePlanForm.footer.cancelButton'}/>
        </DefaultButton>
        <PrimaryButton
          onClick={HandleSaveForm}
          styles={buttonStyles}
          className="ConfirmAction"
        >
          <Trans i18nKey={'medicalInsurancePlanForm.footer.saveButton'}/>
        </PrimaryButton>
      </div>
    );
  };

  const formFields = (
    <Stack {...columnProps}>
      <TextField
        label={t('medicalInsurancePlanForm.props.tittle')} 
        name="txt_title"
        required
        autoComplete="off"
        onChange={onChangeTitleTextFieldValue}
        errorMessage={
          (submittedForm === true && title === undefined) ||
          (submittedForm === true && title !== undefined && title.length === 0)
            ? t('medicalInsurancePlanForm.props.requiredField') 
            : undefined
        }
        value={title || ''}
      />
      <TextField
        label={t('medicalInsurancePlanForm.props.description')}
        name="txt_Description"
        required
        multiline
        onChange={onChangeDescriptionTextFieldValue}
        autoComplete="off"
        rows={1}
        value={Description || ''}
        // errorMessage={
        //   (submittedForm === true && Description === undefined) ||
        //   (submittedForm === true &&
        //     Description !== undefined &&
        //     Description.length === 0)
        //     ? 'Campo requerido'
        //     : undefined
        // }
      />
      <TextField
        label={t('medicalInsurancePlanForm.props.code')}
        name="txt_code"
        required
        autoComplete="off"
        onChange={onChangeCodeTextFieldValue}
        errorMessage={
          (submittedForm === true && Code === undefined) ||
          (submittedForm === true && Code !== undefined && Code.length === 0)
            ? t('medicalInsurancePlanForm.props.requiredField')
            : undefined
        }
        value={Code || ''}
      />
    </Stack>
  );

  // form validation

  const ValidateForm = (): boolean => {
    var validationResult: boolean = true;

    var FormValidation: FormValidation = { success: true, errors: [] };
    setFormValidationStatus(FormValidation);

    if (title === undefined || title.length === 0) {
      validationResult = false;
      FormValidation.errors.push(
        t('medicalInsurancePlanForm.formValidation.informName') 
      );
    }

    // Se elimina la obilgatoriedad de la descripción
    // if (Description === undefined || Description.length === 0) {
    //   validationResult = false;
    //   FormValidation.errors.push('debe informar una descripción');
    // }

    if (Code === undefined || Code.length === 0) {
      validationResult = false;
      FormValidation.errors.push(t('medicalInsurancePlanForm.formValidation.reportPlanCode'));
    }

    FormValidation.success = validationResult;
    setFormValidationStatus(FormValidation);
    return validationResult;
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onDismiss={props.dismissPanel}
      isModeless={false}
      containerClassName={contentStyles.container}
      closeButtonAriaLabel="Close"
      //onRenderFooterContent={onRenderFooterContent}
      // Stretch panel content to fill the available height so the footer is positioned
      // at the bottom of the page
      //isFooterAtBottom={true}
    >
      <div className={contentStyles.header}>
        <span><Trans i18nKey={'medicalInsurancePlanForm.modal.medicalCoveragePlan'}/></span>
        <IconButton
          styles={iconButtonStyles}
          iconProps={cancelIcon}
          ariaLabel="Close popup modal"
          onClick={props.dismissPanel}
        />
      </div>
      {submittedForm && !FormValidationStatus?.success && (
        <MessageBar messageBarType={MessageBarType.error} isMultiline={true}>
          {t('medicalInsurancePlanForm.modal.reviewInformation')}
          <ul>
            {FormValidationStatus?.errors.map(
              (Error: string, index: number) => (
                <li key={index}>{Error}</li>
              )
            )}
          </ul>
        </MessageBar>
      )}
      <div className={contentStyles.body}>
        {MedicalInsurancePlanState &&
          (MedicalInsurancePlanState.failOnAddingNewOne ||
            MedicalInsurancePlanState.failOnUpdatingOne) &&
          MedicalInsurancePlanState.error && (
            <ErrorMessageComponent Error={MedicalInsurancePlanState.error} />
          )}
        {formFields}
      </div>
      {onRenderFooterContent()}
    </Modal>
  );
};

const mapStateToProps = (state: AppState) => ({
  ...state.MedicalInsurancePlans
});

const mapDispatchToProps = {
  ...MedicalInsurancePlanStore.actionCreators
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MedicalInsurancePlanFormComponent as any);

const buttonStyles = { root: { marginRight: 8, class: 'ConfirmAction' } };

const columnProps: Partial<IStackProps> = {
  tokens: { childrenGap: 15 }
  // styles: { root: { width: 150 } }
};

const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    borderRadius: 10
  },
  header: [
    theme.fonts.mediumPlus,
    {
      flex: '1 1 auto',
      color: theme.palette.neutralPrimary,
      display: 'flex',
      alignItems: 'center',
      fontWeight: FontWeights.semibold,
      padding: '0px 12px 12px 12px',
      backgroundColor: 'lightgray',
      borderRadius: '10px 10px 0 0'
    }
  ],
  body: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px',
    overflowY: 'hidden',
    selectors: {
      p: { margin: '14px 0' },
      'p:first-child': { marginTop: 0 },
      'p:last-child': { marginBottom: 0 }
    }
  },
  footer: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px'
  }
});

const cancelIcon: IIconProps = { iconName: 'Cancel' };

const iconButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px'
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
};
